import * as React from "react"
import { Link } from "gatsby";

export default function Footer({showNav, textLeft}){
    
    return(
        <div className={`${textLeft ? 'text-left':'text-center mx-4'}`}>
            {
                showNav &&
                <div className="mt-5">
                    <Link to="/about" className="btn btn-nav">About</Link>
                    <Link to="/faq" className="btn btn-nav">FAQ</Link>
                    <Link to="/privacy" className="btn btn-nav">Privacy Policy</Link>
                </div>
            }
            <p className={`text-light mb-3 mt-2 medium ${textLeft ? 'text-left':'text-center mx-4'}`}> 
                © 2021 Dotastatz. All rights reserved.
            </p>
        </div>
    )
}